require('./kiosk-intro-overlay/kiosk-intro-overlay.scss');
var BaseViews = require('../common/base');
var FarmBranding = require('../common/farm-branding.js');

var KioskIntro = BaseViews.LayoutView.extend({
    className: 'fmcy-plugin-bootstrap fmcy-kiosk-intro-overlay',
    template: require('./kiosk-intro-overlay/kiosk-intro-overlay.html'),
    regions: {
      logoRegion: '.kiosk-intro-overlay-f-logo-region'
    },
    ui: {
      contentWrapper: '.kiosk-intro-overlay-content-wrapper',
      categoryIcon: '.kiosk-menu-intro-cat-icon'
    },
    events: {
        'click @ui.categoryIcon': 'onClick'
    },
    onClick: function (event) {
      if (event.target.id) {
        this.trigger('menu:show:category', event.target.id);
      }
    },
    _renderBranding: function () {
      var branding = new FarmBranding({
        style: 'full',
      });
      this.logoRegion.show(branding);
    },
    onRender: function () {
      this._renderBranding();
    }
});
module.exports = KioskIntro;



/** WEBPACK FOOTER **
 ** ./assets/js/elo-app/kiosk-intro-overlay.js
 **/